import * as React from 'react'
import injectSheet from 'react-jss'
import {WithClasses} from './Helper'
import IconButton from 'material-ui/IconButton'
import NavigationFirstPage from 'material-ui/svg-icons/navigation/first-page'
import NavigationChevronLeft from 'material-ui/svg-icons/navigation/chevron-left'
import NavigationChevronRight from 'material-ui/svg-icons/navigation/chevron-right'
import NavigationLastPage from 'material-ui/svg-icons/navigation/last-page'
import * as Pagination from '../Data/Pagination'
import {singleColors} from '../Style'

const styles = {
    root: {
        display: 'flex',
        alignItems: 'center',
        color: singleColors.labelColor
    },
    button: {
        padding: '0 3px',
        height: 'auto',
        lineHeight: 'auto',
        minWidth: '0',
        color: singleColors.labelColor
    },
    svg: {
        color: singleColors.labelColor
    }
}

interface Properties {
    // tslint:disable-next-line no-any
    readonly pagination: Pagination.Pagination<any>
    readonly onNavigate: (navigation: Pagination.Navigation) => void
}

export const PaginationView =
    injectSheet<Properties>(styles)(
        ({classes, pagination, onNavigate}: WithClasses<Properties>) => {
            const
                {currentPage} = pagination.pageSection,
                numberOfPages = Pagination.numberOfPages(pagination)
            return (
                <div className={classes.root}>
                    <span>
                        {Pagination.rangeDisplay(pagination)}
                    </span>
                    <IconButton
                        className={classes.button}
                        disabled={currentPage === 1}
                        onTouchTap={() => onNavigate({type: 'First'})}
                    >
                        <NavigationFirstPage className={classes.svg}/>
                    </IconButton>
                    <IconButton
                        className={classes.button}
                        disabled={currentPage === 1}
                        onTouchTap={() => onNavigate({type: 'Previous'})}
                    >
                        <NavigationChevronLeft className={classes.svg}/>
                    </IconButton>
                    <span>
                        {currentPage} / {numberOfPages}
                    </span>
                    <IconButton
                        className={classes.button}
                        disabled={currentPage === numberOfPages}
                        onTouchTap={() => onNavigate({type: 'Next'})}
                    >
                        <NavigationChevronRight className={classes.svg}/>
                    </IconButton>
                    <IconButton
                        className={classes.button}
                        disabled={currentPage === numberOfPages}
                        onTouchTap={() => onNavigate({type: 'Last'})}
                    >
                        <NavigationLastPage className={classes.svg}/>
                    </IconButton>
                </div>
            )
        }
    )



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/View/PaginationView.tsx